/**
 * API de supressão de vegetação (ASV) por área Guardian.
 * TIFF original + geometria de indicação desenhada no painel.
 */
import api from './api';

const base = (areaId) =>
  `/guardian/areas/${areaId}/vegetation-suppressions/`;

export const vegetationSuppressionService = {
  list: async (areaId) => {
    const response = await api.get(base(areaId));
    const raw = response.data;
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw?.results)) return raw.results;
    if (Array.isArray(raw?.data)) return raw.data;
    return [];
  },

  get: async (areaId, recordId) => {
    const response = await api.get(`${base(areaId)}${recordId}/`);
    return response.data;
  },

  /**
   * Cria registro com upload multipart do TIFF.
   * @param {string} areaId
   * @param {object} fields - { title, notes, observation_date, status?, area_ha?, image_width?, image_height?, suppression_geometry? }
   * @param {File} tiffFile
   */
  create: async (areaId, fields, tiffFile) => {
    const form = new FormData();
    Object.entries(fields || {}).forEach(([key, value]) => {
      if (value === undefined || value === null || value === '') return;
      if (key === 'suppression_geometry' && typeof value === 'object') {
        form.append(key, JSON.stringify(value));
      } else {
        form.append(key, value);
      }
    });
    if (tiffFile) {
      form.append('original_tiff', tiffFile);
    }
    const response = await api.post(base(areaId), form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  /**
   * Atualiza metadados e/ou geometria de indicação (sem trocar o TIFF).
   */
  update: async (areaId, recordId, fields) => {
    const payload = { ...(fields || {}) };
    const response = await api.patch(`${base(areaId)}${recordId}/`, payload);
    return response.data;
  },

  remove: async (areaId, recordId) => {
    await api.delete(`${base(areaId)}${recordId}/`);
  },
};

export default vegetationSuppressionService;
